import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2fe33780 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _f78f0010 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _aa182bca = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _fbb69eba = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _bcfc257a = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _1b3d89d3 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _7750fb51 = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _294363ec = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _07a9ab16 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _76cbdd96 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _1cb901ea = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _7e9fa1e6 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _5dde1928 = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _56adf0c3 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _3270860a = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _31f62726 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _380f86e6 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _020304fa = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _5b654678 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _5ca895d8 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _7ff0412d = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _62d157e2 = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _2f000d83 = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _3c8e89ec = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _e3582d60 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _6cd7f3d5 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _49909b52 = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _27e9670b = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _57f29aae = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _7bb31542 = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _5b3f6b96 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _55983db7 = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _8c99729c = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _4ba7aa6a = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _344ce4ac = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _3fd24090 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _0586e653 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _1ddb0b4b = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _80ca09da = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _9a243f06 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _7be8c2fd = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _08b87dc9 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _6896ddd6 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _a61333d2 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _5422455a = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _7f38f366 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _8afbe9e0 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _8816e3ac = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _8e37dc9c = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _50f26982 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _2e939189 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _00520ed1 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _523fbe6e = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _04b2d940 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _cbbdcada = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _7cfbb2f8 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _4d9643ab = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _83c95a58 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _01cb2711 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _a59cf708 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _72cfcc60 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _542bb033 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _f33164cc = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _c9dd815c = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _2030617b = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _11d919e8 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _59c8917a = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _990f5cc2 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _0fbf372a = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _5dfb461d = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _f0db125c = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _859c4048 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _27928d30 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _dee7eac4 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _7668a29a = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _4158e5ce = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _2fe33780,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _f78f0010,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _aa182bca,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _fbb69eba,
    name: "calendar"
  }, {
    path: "/customer",
    component: _bcfc257a,
    name: "customer"
  }, {
    path: "/details",
    component: _1b3d89d3,
    name: "details"
  }, {
    path: "/goals",
    component: _7750fb51,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _294363ec,
    name: "maisoku"
  }, {
    path: "/media",
    component: _07a9ab16,
    name: "media"
  }, {
    path: "/privacy",
    component: _76cbdd96,
    name: "privacy"
  }, {
    path: "/project",
    component: _1cb901ea,
    name: "project"
  }, {
    path: "/response",
    component: _7e9fa1e6,
    name: "response"
  }, {
    path: "/sale",
    component: _5dde1928,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _56adf0c3,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _3270860a,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _31f62726,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _380f86e6,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _020304fa,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _5b654678,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _5ca895d8,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _7ff0412d,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _62d157e2,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _2f000d83,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _3c8e89ec,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _e3582d60,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _6cd7f3d5,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _49909b52,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _27e9670b,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _57f29aae,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _7bb31542,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _5b3f6b96,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _55983db7,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _8c99729c,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _4ba7aa6a,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _344ce4ac,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _3fd24090,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _0586e653,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _1ddb0b4b,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _80ca09da,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _9a243f06,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _7be8c2fd,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _08b87dc9,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _6896ddd6,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _a61333d2,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _5422455a,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _7f38f366,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _8afbe9e0,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _8816e3ac,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _8e37dc9c,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _50f26982,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _2e939189,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _00520ed1,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _523fbe6e,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _04b2d940,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _cbbdcada,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _7cfbb2f8,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _4d9643ab,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _83c95a58,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _01cb2711,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _a59cf708,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _72cfcc60,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _542bb033,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _f33164cc,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _c9dd815c,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _2030617b,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _11d919e8,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _59c8917a,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _990f5cc2,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _0fbf372a,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _5dfb461d,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _f0db125c,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _859c4048,
    name: "property-property",
    children: [{
      path: "contact",
      component: _27928d30,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _dee7eac4,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _7668a29a,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _4158e5ce,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
